import axios from "axios";
import { endpointApi } from "../../utils";
import { logout } from "./auth.action";
import { PACKAGING_HISTORY_LIST_FAIL, PACKAGING_HISTORY_LIST_REQUEST, PACKAGING_HISTORY_LIST_SUCCESS } from "../constats/packaging_history.constant";

export const getPackagingHistoryList = (location=null, navigate=null) => async(dispatch) => {
    try {
        const jwt_access = localStorage.getItem('jwt_access');
        dispatch({
            type: PACKAGING_HISTORY_LIST_REQUEST
        });
        const { data } = await axios.get(`${ endpointApi }packaging-histories${ location ? location.search : "" }`, {
            headers: {
                'Authorization': `Bearer ${ jwt_access }`
            }
        });
        dispatch({
            type: PACKAGING_HISTORY_LIST_SUCCESS,
            payload: data
        });
    } catch (err) {
        if(err.response.status === 401){
            dispatch({
                type: PACKAGING_HISTORY_LIST_FAIL,
                payload: null
            });
            const url = location ? location.pathname + location.search : null;
            dispatch(logout(url, navigate));
        }else{
            dispatch({
                type: PACKAGING_HISTORY_LIST_FAIL,
                payload: err.response && err.response.data && err.response.data.message ? err.response.data.message : err.message
            });
        }
    }
}